import { LocalePrefix } from '@tmh-website/shared/const';
import ky from 'ky';
import qs from 'qs';

interface CompareProducts {
  count: number;
  countCaption: string;
  listUrl: string;
  items: CompareProduct[];
  data_id: number;
}
interface CompareProduct {
  id: string;
  product_url: string;
  name: string;
  remove_url: string;
  productScope: string;
}

export interface CustomerDataModule {
  get(type: 'cart'): { subscribe: (event: unknown) => void };
  get(type: 'compare-products'): { subscribe: (event: unknown) => void };
  reload(sections: ['compare-products'], forceNewTimestamp?: boolean): Promise<{ 'compare-products': CompareProducts }>;
}

declare global {
  interface Window {
    requirejs(moduleName: ['Magento_Customer/js/customer-data'], callback: (data: CustomerDataModule) => void): void;
    requirejs(moduleName: string[], callback: (data: unknown) => void): void;
  }
}

export async function getCustomerDataModule(locale: LocalePrefix): Promise<CustomerDataModule> {
  if (process.env.NODE_ENV === 'development' || process.env.APP === 'website') {
    /**
     * During certain environments, we return a mock object since `window.requirejs` is not available.
     * This means that the subscribe logic will not work, as in never fire.
     */
    console.info('Using mock customer data module.');
    return Promise.resolve({
      get: () => ({ subscribe: () => {} }),
      reload: (sections, forceNewTimestamp) =>
        ky
          .get(`/${locale}/customer/section/load`, {
            searchParams: qs.stringify({
              sections: sections.join(','),
              force_new_section_timestamp: forceNewTimestamp,
              _: Date.now(),
            }),
          })
          .json<{ 'compare-products': CompareProducts }>(),
    });
  }
  return new Promise(resolve => {
    window.requirejs(['Magento_Customer/js/customer-data'], resolve);
  });
}
